import { TableCell, TableHead, TableRow } from "@mui/material";

/**
 * Shared header for the two stacked carrier tables (My Carriers and Pending
 * Invites). Kept in one place so their columns stay pixel-aligned.
 */
export function NetworkCarrierTableHead() {
  return (
    <TableHead
      sx={{
        "& th": {
          backgroundColor: "grey.100",
          fontWeight: 600,
          color: "text.secondary",
        },
      }}
    >
      <TableRow>
        <TableCell sx={{ width: "32%" }}>Contact</TableCell>
        <TableCell sx={{ width: "30%" }}>Company</TableCell>
        <TableCell sx={{ width: "18%" }}>Date Added</TableCell>
        <TableCell sx={{ width: "20%" }}>Actions</TableCell>
      </TableRow>
    </TableHead>
  );
}
